import Logo from "./Logo";
import { SideNavBar } from "./SideNavBar";

const LeftMenuDesktop = () => {
  return (
    <>
      <Logo />
      <SideNavBar />
    </>
  );
};

export default LeftMenuDesktop;
